// Constants
import {
    COUNSELLOR_MEETING_DATA,
    INITIALIZE_MEETINGS,
    MEETINGS_LOADING,
} from "@/store/actions/meetingsActions";
const initialState = {
    loading: true,
    data: [],
    counsellorLoading: true,
    counsellorMeetings: [],
};

const meetingsReducer = (state = initialState, action) => {
    if (action.type === INITIALIZE_MEETINGS) {
        return {
            ...state,
            data: action.payload,
            loading: false,
        };
    } else if (action.type == MEETINGS_LOADING) {
        return {
            ...state,
            loading: true,
            counsellorLoading: true,
        };
    } else if (action.type == COUNSELLOR_MEETING_DATA) {
        return {
            ...state,
            counsellorLoading: false,
            counsellorMeetings: action.payload,
        };
    } else {
        return state;
    }
};

export default meetingsReducer;
